/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

export default function data(
  endpointRoles = [],
  onDeleteClick = () => {},
  deletingEndpointRoleId = null
) {
  const getEndpointRoleId = (item) =>
    item?.endpointRoleId ?? item?.EndpointRoleId ?? item?.id ?? item?.Id ?? null;
  const getRoleName = (item) => item?.roleName ?? item?.RoleName ?? "";
  const getEndpointName = (item) => item?.endpointName ?? item?.EndpointName ?? "";
  const getIsActive = (item) => {
    const value = item?.isActive ?? item?.IsActive;
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "active";
    }
    return false;
  };

  return {
    columns: [
      {
        Header: "endpoint",
        accessor: "endpointNameText",
        align: "left",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "role",
        accessor: "roleNameText",
        align: "left",
        Cell: ({ value }) => (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {value}
          </MDTypography>
        ),
      },
      {
        Header: "status",
        accessor: "statusText",
        align: "center",
        Cell: ({ row }) => row.original.status,
      },
      {
        Header: "action",
        accessor: "actionText",
        align: "center",
        Cell: ({ row }) => (
          <MDBox display="flex" justifyContent="center">
            <Tooltip title="Remove Endpoint Role" placement="top">
              <span>
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => onDeleteClick(row.original)}
                  disabled={String(deletingEndpointRoleId) === String(row.original.endpointRoleId)}
                >
                  <Icon fontSize="small">delete</Icon>
                </IconButton>
              </span>
            </Tooltip>
          </MDBox>
        ),
      },
    ],

    rows: endpointRoles.map((item) => {
      const endpointRoleId = getEndpointRoleId(item);
      const isActive = getIsActive(item);
      const endpointName = getEndpointName(item);
      const roleName = getRoleName(item);

      return {
        endpointRoleId,
        endpointNameText: endpointName || "-",
        roleNameText: roleName || "-",
        statusText: isActive ? "active" : "inactive",
        actionText: `ID: ${endpointRoleId ?? "-"}`,
        status: (
          <MDBadge
            badgeContent={isActive ? "active" : "inactive"}
            color={isActive ? "success" : "secondary"}
            variant="gradient"
            size="sm"
          />
        ),
      };
    }),
  };
}
